import styled from '@emotion/styled';

export const OrderItemImage = styled.img({
  width: 22,
  height: 22,
  borderRadius: 4,
  objectFit: 'cover',
});

export const OrderItemName = styled.div((_) => ({
  overflow: 'hidden',
  maxWidth: '320px',
}));
